<section class="pageTitle vh-70 d-flex align-items-center justify-content-center flex-column pt-5">
    <h1 class="mb-5" data-aos="fade-up" data-aos-duration="1000"> @if (isArabic) { تواصل معنا } @else { Contact Us } </h1> 
    <div>
        <span> <a routerLink="/home"> @if (isArabic) { الرئيسية } @else { Home } </a> </span>
        <b class="mx-2"> - </b> 
        <span> <a routerLink="/contact"> @if (isArabic) { تواصل معنا } @else { Contact Us } </a> </span>
     </div>
</section>

<section class="contact-info-section py-5">
    <div class="container">
      <div class="text-center mb-5">
        <h2>{{ isArabic ? 'معلومات الاتصال' : 'Contact Info' }}</h2>
      </div>
      <div class="row g-3">
        <!-- Location -->
        <div class="col-md-4" data-aos="flip-down" data-aos-duration="1000" data-aos-offset="-100">
          <a href="https://maps.app.goo.gl/MWD21HeR9FZr1bJp8" target="_blank" class="text-decoration-none">
            <div class="contact-info-box text-center">
                <div class="icon mb-2">
                  <i class="fa fa-map-marker-alt fa-2x"></i>
                </div>
                <h5>{{ isArabic ? 'الموقع' : 'Location' }}</h5>
                <p>{{ isArabic ? 'الغردقة، مصر' : 'Hurghada, Egypt' }}</p>
            </div>
          </a>
        </div>
        <!-- Phone -->
        <div class="col-md-4" data-aos="flip-down" data-aos-duration="1000" data-aos-offset="-100">
          <a href="tel:+201283015006" target="_blank" class="text-decoration-none">
            <div class="contact-info-box text-center">
                <div class="icon mb-2">
                  <i class="fa fa-phone fa-2x"></i>
                </div>
                <h5>{{ isArabic ? 'اتصال هاتفي' : 'Make a Call' }}</h5>
                <p dir="ltr"> +20 128 301 5006 </p>
            </div>
          </a>
        </div>
        <!-- Email -->
        <div class="col-md-4" data-aos="flip-down" data-aos-duration="1000" data-aos-offset="-100">
          <a href="mailto:info@hurghadaradio.com" target="_blank" class="text-decoration-none">
            <div class="contact-info-box text-center">
                <div class="icon mb-2">
                  <i class="fa fa-envelope fa-2x"></i>
                </div>
                <h5>{{ isArabic ? 'البريد الإلكتروني' : 'Mail' }}</h5>
                <p>info&#64;hurghadaradio.com</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  
</section>

<section class="contact-form py-5">
  <div class="container" data-aos="fade-up" data-aos-duration="1000">
        <h2>@if (isArabic) { للإعلان على راديو الغردقة } @else { To advertise on Hurghada Radio }</h2> 
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
            <div class="mb-2">
              <label for="name" class="form-label">@if (isArabic) { الاسم } @else { Name }</label>
              <input type="text" id="name" class="form-control" formControlName="name" [class.is-invalid]="contactForm.get('name')?.touched && contactForm.get('name')?.invalid" />
              @if (contactForm.get('name')?.touched && contactForm.get('name')?.errors) {
                <div class="invalid-feedback">
                  @if (contactForm.get('name')?.errors?.['required']) { @if (isArabic) { الاسم مطلوب } @else { Name is required } } 
                  @if (contactForm.get('name')?.errors?.['minlength']) { @if (isArabic) { الاسم يجب أن يكون على الأقل 3 أحرف } @else { Name must be at least 3 characters long } } 
                  @if (contactForm.get('name')?.errors?.['maxlength']) { @if (isArabic) { الاسم لا يمكن أن يتجاوز 60 حرفًا  } @else { Name cannot be more than 60 characters } } 
                </div>
              }
            </div>
          
            <div class="mb-2">
              <label for="email" class="form-label">@if (isArabic) { البريد الإلكتروني } @else { Email }</label>
              <input type="email" id="email" class="form-control" formControlName="email" [class.is-invalid]="contactForm.get('email')?.touched && contactForm.get('email')?.invalid" />
              @if (contactForm.get('email')?.touched && contactForm.get('email')?.errors) {
                <div class="invalid-feedback">
                  @if (contactForm.get('email')?.errors?.['required']) { @if (isArabic) { البريد الإلكتروني مطلوب } @else { Email is required } } 
                  @if (contactForm.get('email')?.errors?.['email']) { @if (isArabic) { البريد الإلكتروني غير صالح } @else { Invalid email address } } 
                  @if (contactForm.get('email')?.errors?.['minlength']) { @if (isArabic) { البريد الإلكتروني يجب أن يكون على الأقل 3 أحرف } @else { Email must be at least 3 characters long } } 
                  @if (contactForm.get('email')?.errors?.['maxlength']) { @if (isArabic) { البريد الإلكتروني لا يمكن أن يتجاوز 60 حرفًا }  @else { Email cannot be more than 60 characters }} 
                </div>
              }
            </div>
          
            <div class="mb-2">
              <label for="phone" class="form-label">@if (isArabic) { رقم الهاتف } @else { Phone }</label>
              <input type="number" id="phone" class="form-control" formControlName="phone" [class.is-invalid]="contactForm.get('phone')?.touched && contactForm.get('phone')?.invalid" />
              @if (contactForm.get('phone')?.touched && contactForm.get('phone')?.errors) {
                <div class="invalid-feedback">
                  @if (contactForm.get('phone')?.errors?.['required']) { @if (isArabic) { رقم الهاتف مطلوب } @else { Phone number is required } }
                  @if (contactForm.get('phone')?.errors?.['pattern']) { @if (isArabic) { رقم الهاتف غير صالح. } @else { Invalid phone number }  }
                </div>
              }
            </div>
          
            <div class="mb-2">
              <label for="message" class="form-label">@if (isArabic) { الرسالة } @else { Message }</label>
              <textarea id="message" rows="4" class="form-control" formControlName="message" [class.is-invalid]="contactForm.get('message')?.touched && contactForm.get('message')?.invalid"></textarea>
              @if (contactForm.get('message')?.touched && contactForm.get('message')?.errors) {
                <div class="invalid-feedback">
                  @if (contactForm.get('message')?.errors?.['required']) { @if (isArabic) { الرسالة مطلوبة } @else { Message is required } } 
                  @if (contactForm.get('message')?.errors?.['minlength']) { @if (isArabic) { الرسالة يجب أن تكون على الأقل 10 أحرف } @else { Message must be at least 10 characters long } }
                </div>
              }
            </div>
        
          <button [disabled]="contactForm.invalid" type="submit" class="btn btn-primary">@if (isArabic) { إرسال } @else { Send } <i class="fa-solid fa-paper-plane"></i> </button>
        </form>

        @if (showMessage?.type === 'success') {
          <div class="alert alert-primary mt-3">
            <i class="fa-regular fa-circle-check"></i> @if (isArabic) { لقد تم ارسال رسالتك بنجاح } @else { your message has been sent successfully }
          </div>
        }
        @else if ( showMessage?.type === 'error' ) {
          <div class="alert alert-danger mt-3">
            <i class="fa-solid fa-circle-exclamation"></i> @if (isArabic) { خطا , لم يتم ارسال رسالتك } @else { Error, your message was not sent }
          </div>
        }
  </div>
</section>

<section class="map pb-5">
  <div class="container">
    <div class="text-center mb-5">
      <h3>{{ isArabic ? ' خريطة الغردقة ' : ' Hurghada Map ' }}</h3>
    </div>
    <iframe data-aos="zoom-in" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d227126.29069323136!2d33.78171045!3d27.19250455!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145287b2cd3dbbb3%3A0x2db807f98bd3c360!2z2KfZhNi62LHYr9mC2KnYjCDZhdit2KfZgdi42Kkg2KfZhNio2K3YsSDYp9mE2KPYrdmF2LE!5e0!3m2!1sar!2seg!4v1727598283594!5m2!1sar!2seg" class="w-100 rounded-3" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
</section>
